import React, { useState, useContext } from "react";
import useForm from "../../../../services/UseForm";
import validate from '../../../../validations/admin/basicInfo/statusValidate';
import '../../../../css/popUpForm.css';
import axios from "axios";
import { API } from "../../../../services/api";
import { StatusContext } from "../status";

axios.defaults.baseURL = API;

function CreateStatus(props) {

    const {StatusList, setStatusList} = useContext(StatusContext);

    const handleInputRoleChange = event => {
        const { name, value } = event.target;
        handleChange(name, value)
        check(value);
    };

    const check = (params) => {
        const results = StatusList.filter((data) => {
            return data.Status.toLowerCase() === params.toLowerCase()
        });
        if (results.length > 0)
            handleChange("CheckStatus", results[0].Status);
        else
            handleChange("CheckStatus", "");
    }

    async function saveTutorial() {
        let token = localStorage.getItem("token");
        var data = {
            Status: values.Status,
        }
        await axios.post("/createStatus", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            var obj = {
                StatusID: response?.data?.insertId,
                Status: values.Status,
            }
            StatusList.push(obj);
            setStatusList(StatusList);
            localStorage.setItem("roleData", JSON.stringify(StatusList));
            ClearData();
            props.onClick(false);
        }).catch((err) => {
            console.log(err);
        });
    };

    const ClearData = () => 
        handleChange("Status", "");

    const {
        values,
        errors,
        handleChange,
        handleSubmit,
    } = useForm(saveTutorial, validate);

    return (
        <div style={{ display: props && props.show ? 'flex' : 'none' }} className="popUpForm">
            <div className="popUpcontent">
                <div className="popUpHeader">
                    <span>ສ້າງສະຖານະ</span>
                </div>
                <div className="popUpBody">
                    <form onSubmit={handleSubmit} noValidate>
                        <div className="form-row">
                            <div className="form-group">
                                <span>ສະຖານະ</span>
                                <input className={`input form-control ${errors.Status && 'is-invalid'}`} type="text" name="Status" onChange={(e) => handleInputRoleChange(e)} value={values.Status || ''} required />
                                {errors.Status && (
                                    <p className="invalid-feedback">{errors.Status}</p>
                                )}
                            </div>
                        </div>
                        <div className="popUpfooter">
                            <button type="submit" className="btn btn-primary">
                                ບັນທຶກ
                            </button>
                            <button type="button" onClick={(e) => props.onClick(false)} className="btn btn-danger" data-dismiss="modal" aria-label="Close">
                                ກັບຄືນ
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default CreateStatus;
